import { SMALL_MODAL } from 'consts/modalStyles'

export const MODAL_STYLE = {
  ...SMALL_MODAL,
  content: {
    ...SMALL_MODAL.content,
    padding: '0px',
    width: '80%',
    maxWidth: 564,
  },
}
